{
  "show_site_header": true,
  "hero": {
    "title": "Global trade update",
    "logo_url": "assets/img/2026-global_trade_update_logo.png?v=1",
    "description": "Monthly analysis of the key trends shaping global trade",
    "background_image_url": "assets/img/2026-global_trade_update_hero.jpg?v=3",
    "cta": {
      "label": "Read the update",
      "target_selector": ".current-issue"
    },
    "show_cta": false,
    "show_nav_cards": false,
    "nav_cards": [
      {
        "label": "Monthly policy insights",
        "image_url": "assets/img/2026-global_trade_update_nav_policy_insights.jpg?v=1",
        "target_selector": ".policy-insights"
      },
      {
        "label": "Global trade snapshot",
        "image_url": "assets/img/2026-global_trade_update_nav_global_trade_snapshot.jpg?v=1",
        "target_selector": ".global-trade-snapshot"
      }
    ],
    "pills": [
      {
        "label": "Publications",
        "target_selector": ".publications_container"
      },
      {
        "label": "News",
        "target_selector": ".news_container"
      },
      {
        "label": "Videos",
        "target_selector": ".videos_container"
      },
      {
        "label": "Subscribe",
        "url": "https://unctad.org/subscribe"
      }
    ]
  },
  "stats_strip": {
    "datawrapper_chart_id": "YmLLe",
    "stats": [
      {
        "match": { "column": "label", "value": "card_1" },
        "value_column": "value",
        "label_column": "description",
        "label": "Global biodiversity-based exports, 2024"
      },
      {
        "match": { "column": "label", "value": "card_2" },
        "value_column": "value",
        "label_column": "description",
        "label": "Developing countries' share of global biodiversity-based exports, 2024"
      },
      {
        "match": { "column": "label", "value": "card_3" },
        "value_column": "value",
        "label_column": "description",
        "label": "Top tariff faced by natural substitutes to plastics"
      }
    ]
  },
  "global_trade_snapshot": {
    "title": "Quarterly facts and figures",
    "description": "These graphs highlight key trends in global trade, drawing on the quarterly facts and figures edition of the global trade update.",
    "layout": "",
    "download": {
      "label": "facts and figures edition of the global trade update",
      "datawrapper_chart_id": "YmLLe",
      "match": { "column": "label", "value": "download_url" },
      "value_column": "value"
    },
    "tabs": [
      {
        "label": "Global trade growth",
        "chart_id": "otPNY"
      },
      {
        "label": "Goods vs. services trade",
        "chart_id": "AayJg"
      },
      {
        "label": "Regional trade growth",
        "chart_id": "xqCaY"
      }
    ]
  }
}
